// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GUFo1y","labelWrapper":"xmikAL","inheritLabel":"edWkyw","controlWrapper":"TZhAH9","explain":"awoZEt","isError":"_3JcUQJ","message":"q_FcZ8"};